var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-end my-2"},[_c('div',{staticClass:"px-3 py-2 text-white bg-gray-500 rounded-lg shadow-lg"},[_c('p',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }